import { UPDATE_PORTAL_LOGO } from './index';

export const updatePortalLogoAction = (portal_logo) => ({
    type: UPDATE_PORTAL_LOGO,
    portal_logo
});